import styles from './EmptyResult.styles.m.css';

export const EmptyResult = ({ message }) => {
  return <div className={styles.noResults}>{message}</div>;
};
